// extracted by mini-css-extract-plugin
export default {"toggleOverlay":"NavBarOverlay_toggleOverlay__Q3cmG"};